import { registerPlugin } from '@capacitor/core';

export type PermissionStatus =
  | 'granted'
  | 'denied'
  | 'unknown'
  | 'notSupported';

export interface PermissionResult {
  status: PermissionStatus;
}

export interface CheckPermissionResult {
  critical: PermissionStatus;
  timeSensitive: PermissionStatus;
}

export interface CriticalAlertsPlugin {
  requestPermission(): Promise<PermissionResult>;
  checkPermission(): Promise<CheckPermissionResult>;
}

export const CriticalAlerts =
  registerPlugin<CriticalAlertsPlugin>('CriticalAlerts');
